import { ReactElement } from 'react';
import { Grid, SelectChangeEvent, useEventCallback } from '@mui/material';
import { PmiButton } from 'shell/components/shared/button';
import { useFormikContext } from 'formik';
import { useListener } from 'shell/hooks/use-bus';
import { EventFormPractice } from 'practice/constants/research-state-enum';
import { ResearchActForm } from 'civil-status/view-models/research-form';
import OperatorList from '../../shared/operator-list';
import ListRegister from 'civil-status/components/shared/list-register';
import ListAnsc from 'civil-status/components/shared/list-ansc';
import { ItemVM } from 'shell/view-models/item';
import { DatePicker } from '@mui/lab';
import PmiTextField from 'shell/components/shared/text-field';
import ListStateAct from 'civil-status/components/shared/list-state-research';
import { STATES_ACT } from 'civil-status/constants/states-act';

const FormFilter = (): ReactElement => {
  const formContext = useFormikContext<ResearchActForm>();

  useListener<ResearchActForm>(EventFormPractice.UpdateForm, (form) => {
    formContext.setValues({ ...formContext.values, ...form });
  });

  const onChangeState = useEventCallback((event: SelectChangeEvent<string>) => {
    formContext.setFieldValue('stateAct', event.target.value);
  });

  const onChangeOperator = useEventCallback((event: SelectChangeEvent<string>) => {
    formContext.setFieldValue('codOperator', event.target.value);
  });

  const onChangeRegister = useEventCallback((event: SelectChangeEvent<string>) => {
    formContext.setFieldValue('typeEvent', event.target.value);
  });

  const handleListTypeContent = useEventCallback((item?: ItemVM) => {
    formContext.setFieldValue('typeContent', item?.id?.toString() || '');
  });

  return (
    <Grid container spacing={2}>
      <Grid item xs={12} md={4}>
        <ListStateAct
          value={formContext.values.stateAct || ''}
          error={Boolean(formContext.errors.stateAct) && formContext.touched.stateAct}
          onChange={onChangeState}
          withoutId={STATES_ACT.ID_STATE_FIRMA_COMPLETA_USC}
        />
      </Grid>
      <Grid item xs={12} md={4}>
        <OperatorList
          onChange={onChangeOperator}
          value={formContext.values.codOperator || ''}
          codiceStatoEvento={formContext.values.stateAct || undefined}
          // disabled={!formContext.values.stateAct}
        />
      </Grid>
      <Grid item xs={12} md={4}>
        <ListRegister
          value={formContext.values.typeEvent || ''}
          error={Boolean(formContext.errors.typeEvent) && formContext.touched.typeEvent}
          onChange={onChangeRegister}
          withNessuno
        />
      </Grid>
      <Grid item xs={12} md={4}>
        <ListAnsc
          label="Tipo contenuto"
          idDominio="2"
          value={formContext.values?.typeContent || ''}
          onChange={handleListTypeContent}
          error={Boolean(formContext.errors.typeContent) && formContext.touched.typeContent}
        />
      </Grid>
      <Grid item xs={12} md={4}>
        <DatePicker
          label="Data formazione - inizio"
          aria-label="Data formazione - inizio"
          value={formContext.values?.dataStart || null}
          onChange={(date) => {
            formContext.setFieldValue('dataStart', date);
          }}
          renderInput={(params) => (
            <PmiTextField
              {...params}
              id="dataStart"
              fullWidth
              helperText={formContext.errors?.dataStart}
              error={formContext.touched?.dataStart && Boolean(formContext.errors?.dataStart)}
            />
          )}
        />
      </Grid>
      <Grid item xs={12} md={4}>
        <DatePicker
          label="Data formazione - fine"
          aria-label="Data formazione - fine"
          value={formContext.values?.dataEnd || null}
          onChange={(date) => {
            formContext.setFieldValue('dataEnd', date);
          }}
          renderInput={(params) => (
            <PmiTextField
              {...params}
              id="dataEnd"
              fullWidth
              helperText={formContext.errors?.dataEnd}
              error={formContext.touched?.dataEnd && Boolean(formContext.errors?.dataEnd)}
            />
          )}
        />
      </Grid>
      <Grid item container spacing={2} xs={12} justifyContent="space-between" display="flex">
        <Grid item container spacing={2} xs={12} justifyContent="flex-end" display="flex">
          <Grid item xs={12} md={2}>
            <PmiButton
              variant="contained"
              color="secondary"
              fullWidth
              onClick={() => formContext.resetForm()}
            >
              Pulisci
            </PmiButton>
          </Grid>
          <Grid item xs={12} md={2}>
            <PmiButton variant="contained" color="secondary" fullWidth type="submit">
              Cerca
            </PmiButton>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};

FormFilter.displayName = 'Practice Research - Filter Practice - Form Filter component';

export default FormFilter;
